import { Component, Input, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { UsuarioRegistrarModel } from 'src/app/models/seguridad/UsuarioRegistrarModel';
import { StorageService } from 'src/app/services/storage/storage.service';
import { IUsuarioRegistrarModel } from 'src/app/models/interfaces/seguridad/IUsuarioRegistrarModel';
import { OktaAuthService } from 'src/app/services/OktaAuth/okta-auth.service';
import { SessionModel } from 'src/app/models/seguridad/SesionModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  user: UsuarioRegistrarModel;
  @Input() isAuthenticated: boolean = false;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private storageService: StorageService,
    private companiaService: CompaniaService,
    private seguridadUsuarioService: SeguridadUsuarioService,
    public oktaAuth: OktaAuthService
  ) {
    this.user = new UsuarioRegistrarModel();
  }

  ngOnInit() {


    this.user = this.storageService.getCurrentUser();

    this.storageService.getEmitter().subscribe((value: IUsuarioRegistrarModel) => {
      this.user = value;
    });
    // console.log(this.user);
  }

  logout(): void {
    this.isAuthenticated = false;
    this.storageService.logout();
    this.oktaAuth.logout();
  }

  changecompany(company: CompaniaModel): void {
    let currentSession: SessionModel | null = new SessionModel();
    currentSession = this.storageService.getCurrentSession() as SessionModel;
    currentSession.user.companiaDefault = company;
    this.storageService.setCurrentSession(currentSession);
  }

  setDefault(company: CompaniaModel): void {
    this.confirmDialogService.open(`Esta seguro de establecer a ${company.nombre} como su compañía por defecto?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.companiaService.setDefault(company).subscribe((result: ActionResultModel) => {
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
          else {
            this.alertDialogService.open(`Se estableció a ${company.nombre} como la compañía por defecto para su usuario.`);
            this.seguridadUsuarioService.getCurrent().subscribe(q => {
              let currentSession: SessionModel | null = new SessionModel();
              currentSession = this.storageService.getCurrentSession() as SessionModel;
              currentSession.user.companias = q.companias;
              currentSession.user.companiaDefault = q.companiaDefault;
              this.storageService.setCurrentSession(currentSession);
            });
          }
        });
      }
    });
  }
}
